import api from "../../../api";
import {typedQuery} from "../../typing";

export const deals = typedQuery(["vendorToolkit", "deals"], async () => {
  return await api.vendorToolkit.deals.list();
});
